import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { BehaviorSubject } from 'rxjs';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.url = configService.getURL() + 'auth';
    this.token = new Login();
  }

  /**
   * Metodo que faz login
   * 
   * @param email Email a ser utilizado para logar na aplicacao
   * @param password Senha a ser utilizada para logar na aplicacao
   */
  login(email: string, password: string) {
    return this.http.post<Object[]>(this.url + '/login', { email, password });
  }

  /**
   * Atualiza o token quando expirado
   */
  refresh(){
    return this.http.post<Object[]>(this.url + '/refresh', {}, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  deslogar(){
    return this.http.post<Object[]>(this.url + '/logout', {}, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  /**
   * Dados do usuario logado
   */
  me(){
    return this.http.post<Object[]>(this.url + '/me', {}, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  resetPasswordSendEmail(email){
    return this.http.post<Object[]>(this.url + '/password/email', email);
  }

  resetPasswordAlterarSenha(data){
    return this.http.post<Object[]>(this.url + '/password/reset', data);
  }
}